import styled from 'styled-components'

export const IndicatorIcon = styled.div`
  width: ${ (props) => `${ props.size }px` };
  height: ${ (props) => `${ props.size }px` };
  border-radius: 50%;
  display: flex;
  justify-content: center;
  line-height: ${ (props) => `${ props.size }px` };

  background: ${ (props) => {
    if ('qsr' === props.type) {
      return props.theme.colors['aok-gruen']
    }
    if ('positive' === props.value) {
      return '#669933'
    }

    if ('info' === props.value) {
      return props.theme.colors['icon-grau2']
    }

    if ('warning' === props.value) {
      return props.theme.colors['aok-orange']
    }

    return props.theme.colors['fehler-rot']
  } };

  @media print {
    border-color: ${ (props) => {
      if ('qsr' === props.type) {
        return props.theme.colors['aok-gruen']
      }
      if ('positive' === props.value) {
        return '#669933'
      }

      if ('info' === props.value) {
        return props.theme.colors['icon-grau2']
      }

      return props.theme.colors['fehler-rot']
    } };
  }

  > span {
    color: white;
    line-height: ${ (props) => `${ props.size - 2 }px` };
    display: block;
    margin-left: 1px;
  }
`
